import type { HTMLAttributes } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

type Props = HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode;
};
export const Container = ({ children, ...rest }: Props) => {
  return (
    <section css={container} {...rest}>
      {children}
    </section>
  );
};

const container = css`
  padding: ${theme.spacing(2)};
  background-color: ${theme.colors.white};
  border-radius: ${theme.borderRadius.medium};
  border: 1px solid ${theme.colors.neutral20};
`;
